import { render, staticRenderFns } from "./AProductUnitSelector.vue?vue&type=template&id=ff2a3d00&"
import script from "./AProductUnitSelector.vue?vue&type=script&lang=js&"
export * from "./AProductUnitSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports